import { Col } from 'antd';
import React from 'react';
import { UpdateQueryParams } from '@hooks';
import { v3FieldSortOptions } from './FieldSortOptions';

import {
	ApiCodeToggle,
	ApiCodeToggleQueryParams,
	SearchFilter,
	SearchFilterContainer,
	SearchFilterQueryParams,
	SortByFilter,
	SortByFilterQueryParams,
	TagFilter,
	TagFilterQueryParams
} from '../filters';
import { Else, If, Then } from 'react-if';

export type SalesforceFieldSearchQueryParams = ApiCodeToggleQueryParams &
	SortByFilterQueryParams &
	TagFilterQueryParams &
	SearchFilterQueryParams;

export interface SalesforceFieldSearchProps {
	onChange: UpdateQueryParams<SalesforceFieldSearchQueryParams>;
	queryParams: SalesforceFieldSearchQueryParams;
	showInternalNameToggle?: boolean;
}

export const SalesforceFieldSearch: React.FC<SalesforceFieldSearchProps> = ({
	onChange,
	queryParams,
	showInternalNameToggle
}) =>
	<SearchFilterContainer>
		<Col span={ 12 }>
			<SearchFilter onChange={ onChange } />
		</Col>
		<If condition={ showInternalNameToggle }>
			<Then>
				<Col
					className='align-right'
					span={ 12 }>
					<ApiCodeToggle
						checked={ Boolean(queryParams.useInternal) }
						onChange={ onChange } />
				</Col>
			</Then>
			<Else>
				<Col span={ 12 } />
			</Else>
		</If>
		<Col span={ 12 }>
			<TagFilter onChange={ onChange } />
		</Col>
		<Col
			className='align-right'
			span={ 12 }>
			<SortByFilter
				defaultSortOption={ v3FieldSortOptions[ 1 ] }
				onChange={ onChange }
				options={ v3FieldSortOptions }
				queryParams={ queryParams } />
		</Col>
	</SearchFilterContainer>;

